import React from "react";
import { bool, number, shape, string } from "prop-types";

import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import { MostViewedListing } from "../MostViewedListing";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const RentMainNavDropdown = ({
  is_full_width,
  is_wide,
  title,
  trending_rental
}) => {
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Rentals",
    event_value: trending_rental?.id ? `${trending_rental.id}` : "",
    searchTab: "rentals"
  });
  const rentalsDataGtm = {
    "data-gtm-header-menu": "Rentals"
  };
  const resourcesDataGtm = {
    "data-gtm-header-menu": "Resources"
  };

  return (
    <>
      <S.RentDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Areas</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink href="/for-rent/manhattan" {...rentalsDataGtm}>
                    Manhattan
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/brooklyn" {...rentalsDataGtm}>
                    Brooklyn
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/queens" {...rentalsDataGtm}>
                    Queens
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/bronx" {...rentalsDataGtm}>
                    Bronx
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-rent/staten-island"
                    {...rentalsDataGtm}
                  >
                    Staten Island
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/new-jersey" {...rentalsDataGtm}>
                    New Jersey
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/nyc" {...rentalsDataGtm}>
                    All NYC + NJ
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/apartments-for-rent-near-me"
                    {...rentalsDataGtm}
                  >
                    Near Me
                  </ListItemLink>
                </ListItem>
              </List>
              <Title>Browse</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink
                    href="/no-fee-rentals/nyc"
                    {...resourcesDataGtm}
                  >
                    No-fee Apartments
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/pet-friendly-rentals/nyc"
                    {...resourcesDataGtm}
                  >
                    Pet-Friendly Rentals
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isLast>
              <Title>Popular neighborhoods</Title>
              <List>
                <ListItem>
                  <ListItemLink href="/for-rent/tribeca" {...rentalsDataGtm}>
                    Tribeca
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/ues" {...rentalsDataGtm}>
                    All Upper East Side
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/uws" {...rentalsDataGtm}>
                    All Upper West Side
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-rent/east-village"
                    {...rentalsDataGtm}
                  >
                    East Village
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-rent/williamsburg"
                    {...rentalsDataGtm}
                  >
                    Williamsburg
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/astoria" {...rentalsDataGtm}>
                    Astoria
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-rent/hoboken" {...rentalsDataGtm}>
                    Hoboken
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-rent/jersey-city"
                    {...rentalsDataGtm}
                  >
                    Jersey City
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/rentals/all" {...rentalsDataGtm}>
                    View All
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isAds>
              {trending_rental ? (
                <MostViewedListing listing={trending_rental} />
              ) : null}
            </Column>
          </Container>
        </Dropdown>
      </S.RentDropdownButton>
    </>
  );
};

RentMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  trending_rental: shape({
    id: number
  }),
  title: string
};

RentMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  trending_rental: undefined,
  title: DEFAULT_DROPDOWN_TITLE
};

export default RentMainNavDropdown;
